import { Injectable } from '@angular/core';
import { UrlTree, Router, ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { SnackbarService } from '@shared/snack-bar/snack-bar.service';
import { VoivodeshipsFacade } from '@state/voivodeships';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class VoivodeshipsGuard implements CanActivate {
  constructor(
    private router: Router,
    private voivodeshipsFacade: VoivodeshipsFacade,
    private readonly notifService: SnackbarService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const exitUrlTree = this.router.createUrlTree(['/']);
    return this.voivodeshipsFacade.getVoivodeships$().pipe(
      take(1),
      map(voivos => {
        if (!voivos || !voivos.length) {
          this.notifService.showError('NO_VOIVODESHIPS_CANT_ENTER');
          return exitUrlTree;
        }
        return true;
      })
    );
  }
}
